<template>
  <div v-editable="cms" :class="name" :style="mainCssVars">
    <a-eyebrow v-if="cms.eyebrow" :cms="cms" :class="`${name}__eyebrow`" />
    <a-heading
      v-if="cms.heading"
      :cms="cms"
      :html-tag="heading_size"
      :class="`${name}__heading`"
    />
    <!-- eslint-disable vue/no-v-html -->
    <div
      v-if="copy"
      :class="[`${name}__text`, cms.list_type]"
      v-html="$options.filters.markdown(copy)"
    />
    <!--eslint-enable-->
    <component
      :is="item.component"
      v-for="item in cms.cta"
      :key="item._uid"
      v-editable="item"
      :cms="item"
      type="secondary"
      :class="`${name}__cta`"
    />
  </div>
</template>

<script>
import ACtaV2 from '~/components/atoms/a-ctas/a-cta-v2'
import Colors from '~/mixins/colors'
export default {
  components: { ACtaV2 },
  mixins: [Colors],
  props: {
    cms: {
      type: Object,
      default() {
        return {}
      },
    },
  },
  data() {
    return {
      name: 'a-copy',
    }
  },
  computed: {
    copy() {
      return (this.cms || {}).copy || ''
    },
    heading_size() {
      return (this.cms || {}).heading_size || 'h2'
    },
    mainCssVars() {
      return {
        '--text-color': this.setColor((this.cms.color_text || {}).color),
        '--hover-color': this.setColor((this.cms.color_hover || {}).color),
        '--disabled-color': this.setColor(
          (this.cms.color_disabled || {}).color
        ),
        '--list-type-color':
          this.setColor((this.cms.color_list_type || {}).color) || '#C33CA8',
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.a-copy {
  transition: background-color 0.2s ease-in-out, color 0.2s ease-in-out,
    border 0.2s ease-in-out;
  border-color: var(--text-color);
  color: var(--text-color);

  ::v-deep a,
  ::v-deep .a-cta {
    transition: color 0.2s ease-in-out;
    color: var(--text-color);
    &:hover,
    &:active {
      color: var(--hover-color);
    }
    &:disabled,
    &.disabled {
      color: var(--disabled-color);
    }
  }
}
::v-deep p {
  @include font-size(16, 28px);

  margin: 0 0 30px;
}
::v-deep small {
  @include font-size(14, 24px);
}

::v-deep ul,
::v-deep ol {
  margin: 0;
  padding-left: 18px;
  list-style: none;

  li {
    &::before {
      content: '\25A0';
      display: inline-block;
      color: var(--list-type-color);
      width: 1.5em;
      margin-left: -1.5em;
    }
    .square & {
      &::before {
        content: '\25A0';
      }
    }
    .circle & {
      &::before {
        content: '\25E6';
      }
    }
    .disc & {
      &::before {
        content: '\25CF';
      }
    }

    padding-left: 25px;
    margin-bottom: 16px;

    &:last-child {
      // margin-bottom: 0;
    }
  }
}
</style>
